var CustomerWishlistComponent = Vue.component('customer-wishlist', {
    props: ['wishlistId'],
    data: function () {
        return {
            wishlist: null,
            products: [],
            loaded: false
        };
    },
    created: function() {
        this.fetch('get', 'wishlist/details/' + this.wishlistId, { }, function (response) {
            this.products = response.result.products;
            this.wishlist = response.result.wishlist;
            this.loaded = true;
        }.bind(this));
    },
    computed: {
        isEmpty: function() {
            return this.products.length == 0;
        },
        subtotal: function() {
            return this.products.reduce((sum, product) => sum + (product.price * product.wishlist_quantity), 0);
        },
        total: function() {
            return this.products.reduce((sum, product) => sum + (product.price_vat * product.wishlist_quantity), 0);
        }
    },
    methods: {
        updateQuantity: function(wishlistProductId, quantity) {
            var index = this.products.map(function(product) { 
                return product.wishlist_product_id; 
            }).indexOf(wishlistProductId);

            if (index == -1) {
                return;
            }

            if (!quantity) {
                quantity = 1;
            }

            this.products[index].wishlist_quantity = quantity;

            this.fetch('post', '/wishlist/update-product/' + wishlistProductId, { quantity: quantity }, function (response) {
            }.bind(this));
        },
        removeProduct: function(wishlistProductId) {
            var index = this.products.map(function(product) { 
                return product.wishlist_product_id; 
            }).indexOf(wishlistProductId);

            if (index == -1) {
                return;
            }

            this.products.splice(index, 1);

            this.fetch('post', '/wishlist/delete-product/' + wishlistProductId, { }, function (response) {
            }.bind(this));
        }
    }
});